module.exports = __webpack_public_path__ + "static/media/icon-google.fc86b0f2.svg";